module.exports = __webpack_public_path__ + "img/approved.92d69355.svg";